export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-accent-600 via-accent-500 to-primary-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4">
                随时随地吃瓜
              </h2>
              <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                下载51每日大赛APP，第一时间接收吃瓜爆料推送。支持iOS和Android双平台，界面清爽、加载飞快，让你不错过任何一个热门大瓜。更有独家内容只在APP端发布。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-white text-accent-600 font-medium rounded-full hover:bg-white/90 transition-all duration-200 cursor-pointer text-sm"
                >
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
                <a
                  href="#app"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-white/10 text-white font-medium rounded-full border border-white/30 hover:bg-white/20 transition-all duration-200 cursor-pointer text-sm"
                >
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
              </div>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
                <div className="flex items-center gap-1.5 text-xs text-white/70">
                  <i className="ri-shield-check-line"></i>
                  安全无毒
                </div>
                <div className="flex items-center gap-1.5 text-xs text-white/70">
                  <i className="ri-speed-up-line"></i>
                  极速推送
                </div>
                <div className="flex items-center gap-1.5 text-xs text-white/70">
                  <i className="ri-smartphone-line"></i>
                  双平台支持
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-48 md:w-56 h-48 md:h-56 rounded-2xl overflow-hidden border-4 border-white/20 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20mobile%20app%20interface%20mockup%20for%20news%20and%20gossip%20aggregation%20platform%2C%20dark%20theme%20with%20warm%20orange%20and%20crimson%20accents%2C%20trending%20topics%20feed%20design%2C%20clean%20minimal%20UI%2C%20Chinese%20language%20interface%20elements%2C%20modern%20flat%20design%20style%2C%20professional%20app%20screenshot%20aesthetic&width=500&height=500&seq=app-01&orientation=squarish"
                  alt="51每日大赛APP界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}